import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { nanoid } from 'nanoid';
export default class MessageQueue {
  constructor() {
    _defineProperty(this, "messages", []);
    _defineProperty(this, "subscriber", void 0);
  }
  emit(message) {
    this.messages.push(_objectSpread({
      id: nanoid()
    }, message));
    if (this.subscriber) {
      this.processQueue();
    }
  }
  setSubscriber(subscriber) {
    this.subscriber = subscriber;
    this.processQueue();
  }
  dequeueMessage(messageId) {
    this.messages = this.messages.filter(message => message.id !== messageId);
  }
  processQueue() {
    this.messages.forEach(message => {
      this.subscriber(message);
      this.dequeueMessage(message.id);
    });
  }
}